module.exports = __webpack_public_path__ + "static/media/i_cake-birthday.e56472f8.jpg";